import { initFederation } from '@angular-architects/native-federation';

initFederation()
  .catch(err => console.error('[NF] chatbot init failed', err))
  .then(() => import('./bootstrap'))
  .catch(err => console.error('[NF] chatbot bootstrap failed', err));
